import React from 'react';
import { Save, UploadCloud, FileSpreadsheet, CheckCircle2 } from 'lucide-react';
export function ManualAttendance() {
  return <div className="p-6 max-w-5xl mx-auto space-y-8" data-id="element-1328">
      {/* Section 1: Manual Entry Form */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1329">
        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50" data-id="element-1330">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-1331">
            Manual Entry Form
          </h2>
          <p className="text-sm text-gray-500" data-id="element-1332">
            Add or override attendance for a single employee
          </p>
        </div>

        <div className="p-6" data-id="element-1333">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1334">
            <div data-id="element-1335">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1336">
                Employee <span className="text-red-500" data-id="element-1337">*</span>
              </label>
              <select className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-indigo-500 focus:border-indigo-500 outline-none bg-white" data-id="element-1338">
                <option value="" data-id="element-1339">Select Employee</option>
                <option data-id="element-1340">John Doe</option>
                <option data-id="element-1341">Sarah Smith</option>
                <option data-id="element-1342">Mike Johnson</option>
              </select>
            </div>

            <div data-id="element-1343">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1344">
                Date <span className="text-red-500" data-id="element-1345">*</span>
              </label>
              <input type="date" className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-indigo-500 focus:border-indigo-500 outline-none" data-id="element-1346" />
            </div>

            <div data-id="element-1347">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1348">
                Status <span className="text-red-500" data-id="element-1349">*</span>
              </label>
              <select className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-indigo-500 focus:border-indigo-500 outline-none bg-white" data-id="element-1350">
                <option value="" data-id="element-1351">Select Status</option>
                <option data-id="element-1352">Present</option>
                <option data-id="element-1353">Half Day</option>
                <option data-id="element-1354">Leave</option>
                <option data-id="element-1355">Absent</option>
              </select>
            </div>

            <div data-id="element-1356">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1357">
                Remarks
              </label>
              <input type="text" placeholder="Reason for manual entry..." className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-indigo-500 focus:border-indigo-500 outline-none" data-id="element-1358" />
            </div>
          </div>

          <div className="flex justify-end pt-4 border-t border-gray-100" data-id="element-1359">
            <button className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2.5 px-6 rounded-lg flex items-center gap-2 transition-colors shadow-sm" data-id="element-1360">
              <Save size={18} data-id="element-1361" />
              Save Entry
            </button>
          </div>
        </div>
      </div>

      {/* Section 2: Bulk Upload */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-1362">
        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50" data-id="element-1363">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-1364">Bulk Upload</h2>
          <p className="text-sm text-gray-500" data-id="element-1365">
            Upload an Excel file to update multiple records at once
          </p>
        </div>

        <div className="p-6" data-id="element-1366">
          <div className="border-2 border-dashed border-gray-300 rounded-xl p-10 flex flex-col items-center justify-center bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer mb-6" data-id="element-1367">
            <div className="w-16 h-16 bg-white rounded-full shadow-sm flex items-center justify-center text-indigo-500 mb-4" data-id="element-1368">
              <UploadCloud size={32} data-id="element-1369" />
            </div>
            <h3 className="text-lg font-semibold text-gray-800 mb-1" data-id="element-1370">
              Drag & Drop your Excel file here
            </h3>
            <p className="text-sm text-gray-500 mb-6" data-id="element-1371">
              or click to browse from your computer (Max 5MB)
            </p>
            <button className="bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium py-2 px-6 rounded-lg flex items-center gap-2 shadow-sm transition-colors" data-id="element-1372">
              <FileSpreadsheet size={18} data-id="element-1373" />
              Select File
            </button>
          </div>

          {/* Mock Preview Table */}
          <div className="mb-6" data-id="element-1374">
            <h4 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-1375">
              Preview Data (3 records found)
            </h4>
            <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-1376">
              <table className="w-full text-sm text-left" data-id="element-1377">
                <thead className="bg-gray-50 text-xs font-semibold text-gray-600 uppercase border-b border-gray-200" data-id="element-1378">
                  <tr data-id="element-1379">
                    <th className="px-4 py-2" data-id="element-1380">Emp ID</th>
                    <th className="px-4 py-2" data-id="element-1381">Date</th>
                    <th className="px-4 py-2" data-id="element-1382">Status</th>
                    <th className="px-4 py-2" data-id="element-1383">Valid</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200" data-id="element-1384">
                  <tr className="bg-white" data-id="element-1385">
                    <td className="px-4 py-2" data-id="element-1386">EMP001</td>
                    <td className="px-4 py-2" data-id="element-1387">2023-10-12</td>
                    <td className="px-4 py-2" data-id="element-1388">Present</td>
                    <td className="px-4 py-2" data-id="element-1389">
                      <CheckCircle2 size={16} className="text-green-500" data-id="element-1390" />
                    </td>
                  </tr>
                  <tr className="bg-white" data-id="element-1391">
                    <td className="px-4 py-2" data-id="element-1392">EMP002</td>
                    <td className="px-4 py-2" data-id="element-1393">2023-10-12</td>
                    <td className="px-4 py-2" data-id="element-1394">Absent</td>
                    <td className="px-4 py-2" data-id="element-1395">
                      <CheckCircle2 size={16} className="text-green-500" data-id="element-1396" />
                    </td>
                  </tr>
                  <tr className="bg-white" data-id="element-1397">
                    <td className="px-4 py-2" data-id="element-1398">EMP003</td>
                    <td className="px-4 py-2" data-id="element-1399">2023-10-12</td>
                    <td className="px-4 py-2" data-id="element-1400">Half Day</td>
                    <td className="px-4 py-2" data-id="element-1401">
                      <CheckCircle2 size={16} className="text-green-500" data-id="element-1402" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex justify-end pt-4 border-t border-gray-100" data-id="element-1403">
            <button className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2.5 px-6 rounded-lg transition-colors shadow-sm" data-id="element-1404">
              Confirm Upload
            </button>
          </div>
        </div>
      </div>
    </div>;
}